import QRCodeVue3 from "./QRCodeVue3.vue";

export default QRCodeVue3;
